import { BRAND, STATUS_META, STAFF_COLORS, THEMES } from "../config/constants";

/**
 * Status pill style — used on kanban cards, client detail, etc.
 */
export const sp = (status, theme) => {
  const m = STATUS_META[status] || STATUS_META["Engagement Sent"];
  return {
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 700,
    background: m.bg(theme),
    color: m.text,
    border: `1px solid ${m.border}40`,
    whiteSpace: "nowrap",
  };
};

/**
 * Client type pill style (Individual / Business).
 */
export const tp = (type, theme) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "2px 9px",
  borderRadius: 20,
  fontSize: 11,
  fontWeight: 600,
  background:
    type === "Individual"
      ? theme === "dark"
        ? "#0e2040"
        : "#e8f4fd"
      : theme === "dark"
      ? "#0e2818"
      : "#edfaf0",
  color: type === "Individual" ? BRAND.blue : BRAND.green,
  border: `1px solid ${
    type === "Individual" ? BRAND.blue : BRAND.green
  }30`,
});

/**
 * Staff avatar circle.
 */
export const staffAvatar = (name, size = 24) => {
  const color = STAFF_COLORS[name] || BRAND.gray;
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color + "22",
        border: `2px solid ${color}50`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.42,
        fontWeight: 800,
        color,
        flexShrink: 0,
      }}
    >
      {name?.[0] || "?"}
    </div>
  );
};

/**
 * Input field style helper.
 */
export const inpStyle = (t) => ({
  width: "100%",
  background: t.inputBg,
  border: `1px solid ${t.border}`,
  borderRadius: 8,
  padding: "9px 12px",
  color: t.text,
  fontSize: 13,
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "'Outfit',sans-serif",
});

/**
 * Label style.
 */
export const lbl = {
  display: "block",
  fontSize: 11,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  marginBottom: 5,
};

/**
 * Section title style.
 */
export const secT = (t) => ({
  fontSize: 10.5,
  color: t.textMuted,
  textTransform: "uppercase",
  letterSpacing: "0.1em",
  fontWeight: 700,
  marginBottom: 12,
  paddingBottom: 8,
  borderBottom: `1px solid ${t.border}`,
});

/**
 * Primary button style.
 */
export const btnP = {
  padding: "9px 18px",
  borderRadius: 8,
  background: `linear-gradient(135deg,${BRAND.blue},#1a8bbf)`,
  border: "none",
  color: "#fff",
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontFamily: "'Outfit',sans-serif",
};

/**
 * Secondary button style.
 */
export const btnS = (t) => ({
  padding: "9px 18px",
  borderRadius: 8,
  background: t.surfaceAlt,
  border: `1px solid ${t.border}`,
  color: t.textSub,
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: "'Outfit',sans-serif",
});
